import './utils/suppressDeprecatedWarnings'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { installAuthInterceptors } from './utils/authToken'

// Attach a real backend bearer token to every API call (the visible login is only a UI gate).
installAuthInterceptors()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
